import { app, ojs, Component, v, payload } from "modular-openscriptjs";
import { monetary, either } from "../../helpers";
import MoreOptions from "../Blocks/MoreOptions";
import CartQuantityForm from "../Forms/CartQuantityForm";
import { dc } from "../../declarations";

const h = app("h");

ojs(MoreOptions, CartQuantityForm);

export default class ProductNameView extends Component {
	render(productState, ...args) {
		let product = productState.value;

		if (!product?.id) return h.empty();

		let user = product?.owner;

		if (product?.is_copied) {
			user = product?.copier;
		}

		return h.div(
			{
				class: "d-flex flex-column gap-3 p-3 bg-white rounded-4 shadow-sm position-relative h-100 transition-all hover-shadow-md",
				data_product_id: product?.id,
				$data_product_id: product?.id,
			},

			// Header: User Info & More Options
			h.div(
				{
					class: "d-flex justify-content-between align-items-start",
				},
				// User Info
				h.div(
					{
						class: "d-flex align-items-center gap-2",
						role: "button",
						onclick: h.func("app('router').to", "product.view-product", {
							productId: product?.id,
							u: user?.id,
						}),
					},
					h.div(
						{
							class: "d-flex flex-column",
						},
						h.span(
							{
								class: "fw-bold text-dark text-truncate",
								style: "max-width: 150px;",
							},
							product?.name
						),
						h.span(
							{ class: "fs-xsm text-muted" },
							"by ",
							h.span(
								{ class: "fw-500" },
								either(
									user?.display_name?.length > 15,
									user?.display_name?.substring(0, 14) +
										"...",
									user?.display_name
								)
							)
						)
					)
				),

				// More Options
				h.div(
					{
						role: "button",
						class: "btn btn-icon btn-sm btn-ghost-secondary rounded-circle",
						style: "width: 32px; height: 32px;",
					},
					h.MoreOptions([
						h.i({ class: "fas fa-ellipsis-vertical" }),
						h.ul(
							{ class: "list-unstyled m-0 dropdown-menu-end" },
							either(
								(product.owner_id == app("gc").user?.id &&
									product.pivot?.user_id ==
										app("gc").user?.id) ||
									(app("gc").user?.id ==
										product.pivot?.user_id &&
										app("gc").user?.id == user?.id &&
										product.parent_product != null),
								() =>
									h.li(
										h.div(
											{
												role: "button",
												class: "dropdown-item d-flex align-items-center gap-2",
												onclick: this.method(
													"editProduct",
													product
												),
												title: "Edit Product",
											},
											h.i({
												class: "fa-solid fa-pen text-muted width-20",
											}),
											h.span("Edit")
										)
									)
							),

							either(product.owner_id == app("gc").user?.id, () =>
								h.li(
									h.div(
										{
											role: "button",
											class: "dropdown-item d-flex align-items-center gap-2",
											onclick: this.method(
												"copyProduct",
												product
											),
											title: "Copy Product",
										},
										h.i({
											class: "fa-solid fa-copy text-muted width-20",
										}),
										h.span("Copy & Edit")
									)
								)
							),
							either(
								product.owner_id != app("gc").user?.id &&
									product.is_copyable == 1,
								() =>
									h.li(
										h.div(
											{
												role: "button",
												class: "dropdown-item d-flex align-items-center gap-2",
												onclick: this.method(
													"copyProduct",
													product
												),
												title: "Clone Product",
											},
											h.i({
												class: "fa-solid fa-clone text-muted width-20",
											}),
											h.span("Clone & Edit")
										)
									)
							),
							either(
								product.is_private == 0 ||
									(app("gc").user.id == user?.id &&
										product.owner_id == app("gc").user.id &&
										product.pivot?.user_id == user?.id),
								() => [
									h.li(
										h.div(
											{
												role: "button",
												class: "dropdown-item d-flex align-items-center gap-2",
												title: "Share on WhatsApp",
												onclick: this.method(
													"shareProduct",
													product
												),
											},
											h.i({
												class: "fa-brands fa-whatsapp text-success width-20",
											}),
											h.span("Share")
										)
									),

									h.li(
										h.div(
											{
												role: "button",
												class: "dropdown-item d-flex align-items-center gap-2",
												title: "Share QR Code",
												onclick: this.method(
													"showQrCode",
													product
												),
											},
											h.i({
												class: "fas fa-qrcode text-muted width-20",
											}),
											h.span("Share (QR)")
										)
									),
								]
							),

							either(
								(!app("router").is("user.view-cart") &&
									product.owner_id == app("gc").user?.id &&
									product.pivot?.user_id ==
										app("gc").user?.id) ||
									(app("gc").user?.id ==
										product.pivot?.user_id &&
										app("gc").user?.id == user?.id &&
										product.parent_product != null),
								() =>
									h.li(
										h.div(
											{
												role: "button",
												class: "dropdown-item d-flex align-items-center gap-2 text-danger",
												title: "Delete Product",
												onclick: this.method(
													"deleteProduct",
													product
												),
											},
											h.i({
												class: "fa-solid fa-trash-can width-20",
											}),
											h.span("Delete")
										)
									)
							)
						),
					])
				)
			),

			// Price and Action
			h.div(
				{
					class: "d-flex justify-content-between align-items-end mt-auto",
				},
				h.div(
					{ class: "d-flex flex-column" },
					h.span(
						{ class: "fs-xsm text-muted text-uppercase fw-bold" },
						"Price"
					),
					h.span(
						{ class: "fs-5 fw-bold text-primary" },
						either(
							product?.price == 0,
							"Task",
							monetary(product?.price, dc.userCurrency)
						)
					)
				),

				h.div(
					either(
						product?.chat_to_order,
						() =>
							h.button(
								{
									class: "btn btn-success btn-icon rounded-circle shadow-sm d-flex align-items-center justify-content-center",
									style: "width: 42px; height: 42px;",
									onclick: this.method(
										"initiateChatOrder",
										product.id
									),
									title: "Order via WhatsApp",
								},
								h.i({
									class: "fa-brands fa-whatsapp fs-5",
								})
							),
						() =>
							h.button(
								{
									class: "btn btn-primary btn-icon rounded-circle shadow-sm d-flex align-items-center justify-content-center",
									style: "width: 42px; height: 42px;",
									onclick: this.method("addToCart", product),
									title: "Add to Cart",
								},
								v(app("uc").cartMap, (cartMap) => {
									return either(
										product?.id in cartMap.value,
										h.span(
											{
												class: "fw-bold fs-sm",
											},
											cartMap.value[product?.id]?.item
												?.qty
										),
										h.i({ class: "fas fa-plus fs-6" })
									);
								})
							)
					)
				)
			),

			...args
		);
	}

	addToCart(product) {
		if (product.id in app("uc").cartMap.value) {
			return this.updateItem(app("uc").cartMap.value[product.id].item);
		}

		app("broker").broadcast(
			app("$e").cart.itemSelected,
			payload({ item: product })
		);
	}

	editProduct(product) {
		app("broker").send(
			app("$e").product.needs.update,
			payload({ item: product })
		);
	}

	updateItem(item) {
		app("broker").send(
			app("$e").cart.needs.itemUpdateForm,
			payload({ item })
		);
	}

	deleteProduct(product) {
		app("broker").send(
			app("$e").product.needs.deletion,
			payload({ id: product.id })
		);
	}

	shareProduct(product) {
		app("broker").send(
			app("$e").product.needs.share,
			payload({ id: product.id, product })
		);
	}

	copyProduct(product) {
		product.original_product_id = product.id;
		delete product.id;
		app("broker").send(
			app("$e").product.needs.creation,
			payload({ item: product })
		);
	}

	removeItem(item) {
		app("broker").send(
			app("$e").cart.needs.itemRemoval,
			payload({ rowId: item?.rowId })
		);
	}

	like(product) {
		app("broker").send(app("$e").product.needs.like, payload({ product }));
	}

	unlike(product) {
		app("broker").send(
			app("$e").product.needs.unlike,
			payload({ product })
		);
	}

	showQrCode(product) {
		app("broker").send(
			app("$e").qr.needs.code,
			payload({
				title: `${product.name} - Item QR Code`,
				data: `/products/${product?.id}/view`,
			})
		);
	}

	initiateChatOrder(productId) {
		app("broker").send(
			app("$e").user.needs.to.orderViaChat,
			payload({ order_product_id: productId })
		);
	}
}
